import { render, staticRenderFns } from "./AddClients.vue?vue&type=template&id=a7502fd2&scoped=true&"
import script from "./AddClients.vue?vue&type=script&lang=js&"
export * from "./AddClients.vue?vue&type=script&lang=js&"
import style0 from "./AddClients.vue?vue&type=style&index=0&id=a7502fd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7502fd2",
  null
  
)

export default component.exports